/**
 * 认证枚举
 */
enum AuthState {
    UNCHECK = '未认证',
    CHECKING = '认证中',
    FAILED = '认证失败',
    PASS = '已认证'
}
/**
 * 收票枚举
 */
enum LoggingState {
    UN_RECEIVE = '未收票',
    RECEIVED = '已收票',
    REJECTED = '已拒绝',
}
/**
 * 发票枚举
 */
enum InvoiceState {
    NORMAL = '正常',
    CANCELLED = '作废',
    RED = '红冲',
    ABNORMAL = '异常',
    UNCONTROLLED = '失控',
}
/**
 * 勾选状态
 */
enum DraftState {
    DRAFT_UNCOMMIT = "未勾选",
    DRAFT_COMMIT = "已勾选",
    DRAFT_PUSHED = "已勾选",
    DRAFT_COMMIT_ING = "勾选中",
    DRAFT_CANEL_ING = "取消中"
}

export { AuthState, LoggingState, InvoiceState, DraftState };


// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/StateEnum.ts